import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/app/App';
import { recargarSiFaltaUnChunk } from '@/app/lazyPage';
import '@/index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Root element #root not found in index.html. ' +
      'Verify the HTML structure.',
  );
}

recargarSiFaltaUnChunk();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
